<template>
   <div class="mzl-subjects__select form__select-free">
        <div class="form__label-wrapper">
            <label for="" class="form__select-free-label">
                {{ this.title }}
            </label>
        </div>
        <div class="form__select-free-wrapper">								
            <select class="form__select-free-el" id="mzl_select1" @change="changeOption($event)">
                <option selected="" value="">{{ this.defaultOptionText }}</option>
                <template v-for="item in selectOptionsSubject">										
                    <option>{{ item[optionSelector] }}</option>
                </template>   
            </select>
        </div>
    </div>         
</template>

<script>
    export default {
        name: "SubjectItem",
        props: {
            title: {
                type: String,
                required: true
            },
            subject: {
                type: String,
                required: true
            },            
            selectOptionsSubject: {
                type: Array,
                required: true,
                default: () => []
            },
            optionSelector: {
                type: String,
                required: true
            },
            defaultOptionText: {
                type: String,
                required: true,
                default: 'Bitte wählen Sie...'
            }
        },        
        methods: {
            changeOption($event) {                
                this.$emit('subjectSelected', $event.target.value, this.subject);
            }
        }
    }
</script>